import Link from "next/link";

import Container from "../../components/landing/Container";
import HeadComponent from "../../components/landing/Head";
import Press from "../../components/landing/Press";
import items from "../../data/press/items.json";
import SEO from "../../data/seo.json";
import Image from "next/image";

const PRESS_DATA = items.find(i => i.name === "datamynt-customers");

function DataMyntSolana() {
  return (
    <div>
      <HeadComponent SEO={SEO} />
      <Container>
        <Press item={PRESS_DATA}>
          <p className={"font-semibold text-lg"}>
            Since launching its crypto as currency solutions for businesses,
            Data Mynt has enabled its 500th customer, an IHG (Intercontinental
            Hotels Group) property in Mexico City, to accept payments from
            millions of crypto customers and also send payments to team and
            suppliers globally.
          </p>

          <div className={"space-y-2 md:hidden"}>
            <div
              className={"relative w-full h-[250px] overflow-hidden rounded-xl"}
            >
              <Image
                alt={"customer 2"}
                src={"/500_customers_2.png"}
                layout={"fill"}
                objectFit={"cover"}
              />
            </div>
            <p className={"text-black"}>
              <b>
                Image: Check-in counter at IHG Mexico City with &apos;Data Mynt
                We Accept Crypto Instructions&apos;
              </b>
            </p>
          </div>

          <p className={"text-gray-50"}>
            With over 200,000,000 consumers buying and owning cryptocurrency in
            the same emerging markets where Visa and Mastercard card decline
            rates top 70% and cross border payment settlement times reach 7
            days, Data Mynt unlocks the efficiency and security of
            multi-currency blockchain payments for its business customers.
          </p>

          <p className={"text-gray-50"}>
            Through its on the ground team and local presence, Data Mynt today
            supports on and offline businesses across Nigeria, Kenya, Ghana,
            South Africa, Mexico, and the Philippines.
          </p>

          <div className={"flex items-center space-x-8"}>
            <div>
              <svg
                width="93"
                height="68"
                viewBox="0 0 93 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.3">
                  <path
                    d="M35.4316 0L39.7465 8.855C28.3005 13.363 24.6063 22.9233 24.19 27.14C32.29 28.6733 46.923 36.041 40.655 53.245C34.3869 70.449 17.9824 68.0033 10.5637 64.63C5.3782 62.3683 -3.67566 52.624 1.59314 31.74C6.86194 10.856 26.3474 1.87833 35.4316 0Z"
                    fill="#3D8ECD"
                  />
                  <path
                    d="M86.2577 0L90.5727 8.855C79.1267 13.363 75.4325 22.9233 75.0161 27.14C83.1161 28.6733 97.7492 36.041 91.4811 53.245C85.2131 70.449 68.8086 68.0033 61.3899 64.63C56.2044 62.3683 47.1505 52.624 52.4193 31.74C57.6881 10.856 77.1736 1.87833 86.2577 0Z"
                    fill="#3D8ECD"
                  />
                </g>
              </svg>
            </div>
            <p className={"text-gray-50"}>
              “Our localized product, go to market approach and customer
              understanding is solving acute pain points for traditionally
              underserved businesses.” said Alex Christian, CEO of Data Mynt.
            </p>
          </div>

          <p className={"text-gray-50"}>
            Interested merchants and businesses can add Data Mynt digital asset
            checkout now at{" "}
            <Link href="https://play.google.com/store/apps/details?id=com.datamynt">
              <a className={"text-primary underline"}>Google Play Store</a>
            </Link>{" "}
            and{" "}
            <Link href="https://apps.apple.com/us/app/datamynt-point-of-sale-pos/id1572840222">
              <a className={"text-primary underline"}>App Store</a>
            </Link>
            .
          </p>

          <div className={"space-y-2 md:hidden"}>
            <div
              className={"relative w-full h-[250px] overflow-hidden rounded-xl"}
            >
              <Image
                src={"/500_customers_1.jpeg"}
                layout={"fill"}
                objectFit={"cover"}
              />
            </div>
            <p className={"text-black"}>
              <b>
                Image: Business owner in Nigeria showing off &apos;Data Mynt We
                Accept Crypto Instructions&apos;
              </b>
            </p>
          </div>

          <div className={"hidden md:grid grid-cols-2 w-full gap-8"}>
            <div className={"space-y-2"}>
              <div
                className={
                  "relative w-full h-[250px] overflow-hidden rounded-xl"
                }
              >
                <Image
                  alt={"customer 1"}
                  src={"/500_customers_1.jpeg"}
                  layout={"fill"}
                  objectFit={"cover"}
                />
              </div>
              <p className={"text-black"}>
                <b>
                  Image: Business owner in Nigeria showing off &apos;Data Mynt
                  We Accept Crypto Instructions&apos;
                </b>
              </p>
            </div>

            <div className={"space-y-2"}>
              <div
                className={
                  "relative w-full h-[250px] overflow-hidden rounded-xl"
                }
              >
                <Image
                  alt={"customer 2"}
                  src={"/500_customers_2.png"}
                  layout={"fill"}
                  objectFit={"cover"}
                />
              </div>
              <p className={"text-black"}>
                <b>
                  Image: Check-in counter at IHG Mexico City with &apos;Data
                  Mynt We Accept Crypto Instructions&apos;
                </b>
              </p>
            </div>
          </div>

          <h6 className={"text-black text-md"}>About DataMynt</h6>
          <p className="text-gray-50">
            With Data Mynt, you can run your business from your pocket using
            secure, compliant crypto as currency payments and financial
            operations infrastructure. Its suite of business tracking,
            notifications, wallet, fiat on off ramps, customer engagement, and
            payment solutions offers businesses of all sizes an easy approach to
            growing your business free from traditional cryptocurrency
            volatility and the usual risks and costs of traditional payment
            methods such as cards. Learn more:
          </p>

          <ul className={"flex space-x-4"}>
            <li>
              <Link target={"_blank"} href={"https://datamynt.com"}>
                <a className={"text-primary font-semibold"}>Website</a>
              </Link>
            </li>
            <p>|</p>
            <li>
              <Link target={"_blank"} href={"https://twitter.com/DataMynt"}>
                <a className={"text-primary font-semibold"}>Twitter</a>
              </Link>
            </li>
            <p>|</p>
            <li>
              <Link
                target={"_blank"}
                href={"https://www.linkedin.com/company/datamynt/"}
              >
                <a className={"text-primary font-semibold"}>LinkedIn</a>
              </Link>
            </li>
          </ul>
        </Press>
      </Container>
    </div>
  );
}

export default DataMyntSolana;
